import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const courses = [
    { id: 1, title: "Introduction to Data Engineering", category: "Data Engineering", difficulty: "Beginner", description: "Fundamentals of data engineering, pipelines, and data storage.", takenBy: 150 },
    { id: 2, title: "ETL Processes and Tools", category: "Data Engineering", difficulty: "Intermediate", description: "Understanding Extract, Transform, Load (ETL) processes and tools.", takenBy: 120 },
    { id: 3, title: "SQL for Data Engineers", category: "Data Engineering", difficulty: "Beginner", description: "Master SQL for building efficient data pipelines and querying data.", takenBy: 200 },
    { id: 4, title: "Big Data Technologies", category: "Data Engineering", difficulty: "Advanced", description: "Learn to work with large-scale data using Hadoop, Spark, and more.", takenBy: 75 },
    { id: 5, title: "Data Analytics with Python", category: "Data Analytics", difficulty: "Intermediate", description: "Applying Python for data analysis and visualization.", takenBy: 110 },
    { id: 6, title: "Data Visualization", category: "Data Analytics", difficulty: "Intermediate", description: "Creating powerful data visualizations using tools like Tableau and Power BI.", takenBy: 95 },
    { id: 7, title: "Cloud Data Engineering", category: "Data Engineering", difficulty: "Advanced", description: "Building scalable and secure data pipelines in the cloud.", takenBy: 85 },
    { id: 8, title: "Advanced Data Analytics", category: "Data Analytics", difficulty: "Advanced", description: "Advanced techniques in data analysis using Python and R.", takenBy: 65 },
];

const pageSize = 4;

function DataEngineeringAnalytics() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Beginner");

    const filteredCourses = courses.filter(course => course.difficulty === activeTab);
    const paginatedCourses = filteredCourses.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Data Engineering & Analytics</Title>
                <Paragraph>Explore essential courses in Data Engineering and Analytics to advance your career in building data pipelines and analyzing large-scale data.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedCourses.map((course) => (
                        <Col xs={24} sm={12} md={6} key={course.id}>
                            <Card hoverable>
                                <Title level={5}>{course.title}</Title>
                                <Tag color="blue">{course.category}</Tag>
                                <Tag color={course.difficulty === "Beginner" ? "green" : course.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {course.difficulty}
                                </Tag>
                                <Paragraph>{course.description}</Paragraph>
                                <Paragraph><UserOutlined /> {course.takenBy} students enrolled</Paragraph>
                                <Button type="primary">Start Course</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredCourses.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default DataEngineeringAnalytics;
